import { render, staticRenderFns } from "./log-autentikasi.vue?vue&type=template&id=c0512288&"
import script from "./log-autentikasi.vue?vue&type=script&lang=js&"
export * from "./log-autentikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports